import React, { useState, useEffect } from 'react'
import InitialLetters from '../../../../../../../utils/InitialLetters';
import FormatPhoneNumber from '../../../../../../../utils/FormatPhoneNumber';
import PrintPreviewTherapyNote from './PrintPreviewTherapyNote';
import AddNewPsychoTherapy from './AddNewPsychoTherapy';
import { FindFirstChild } from '../../../../../../../utils/FindMenuOption';
import { useSelector } from 'react-redux';

const PatientInformation = ({ data, enCounterData, ...props }) => {
    console.log('PatientInformationDATA', data,);
    const [openPsychotherapyPopup, setOpenPsychotherapyPopup] = useState(false);
    const [printoutModal, setPrintoutModal] = useState(false);
    // const [psychoTherapy, setPsychoTherapy] = useState(data);
    let isViewAllowed =  true;
    let IsEditAllowed =  true;
    let IsDeleteAllowed =  true;
    let IsProvider = useSelector(state => state.IsUserProvider)

    // console.log("psychoTherapy", psychoTherapy)

    const handleClosePsychotherapy = (action = '') => {
        setOpenPsychotherapyPopup(false);
        if([ 'Saved', 'Print', 'Deleted'].includes(action)){
            props?.setIsRecordSaved(true);
        }
        if(action === 'Print'){
            setTimeout(() => setPrintoutModal(true), 0);
        }
    }
    // useEffect(() => {
    //     setPsychoTherapy(data);
    // }, [data?.PsychotherapyNoteID])
    
    let noValExistText = <p className="fst-italic light-clrs text">No data recorded</p>;

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }
    const AddPsychoTherapyNote = (ID) => {
        // if(!isViewAllowed) return;
        // setProblemsID(ID)
        setOpenPsychotherapyPopup(true);
    }
    return (
        <>
        {openPsychotherapyPopup ?
            <AddNewPsychoTherapy openPsychotherapyPopup={openPsychotherapyPopup} handleClosePsychotherapy={handleClosePsychotherapy} setPrintoutModal={setPrintoutModal} 
            data={data} 
            // setData={setPsychoTherapy}  
            // IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
            setIsRecordSaved={props?.setIsRecordSaved}
            /> : <></>}

            {(!openPsychotherapyPopup 
            // && !props?.isRecordSaved 
            && data?.PsychotherapyNoteID 
            && printoutModal) ?
            <PrintPreviewTherapyNote printoutModal={printoutModal} setPrintoutModal={setPrintoutModal} data={data}/> : <></>}
            <div className="br-bottom-1px d-flex flex-column gap-1 p-2 za-light">
                <div className="d-flex align-items-center gap-6 pb-1">
                    <div className="img-container s-40 circle">
                        <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${data?.Gender === 'Male' ? 'za-male' : data?.Gender === 'Female' ? 'za-female' : 'za-others'
                            }`}>

                            {enCounterData?.ProfilePictureURL ?
                                <img src={enCounterData?.ProfilePictureURL} alt="" /> :
                                <InitialLetters classes={""} name={data?.Patient} splitBy={' '} />
                            }</p>
                    </div>
                    <div className='pateint_name'>
                        <div className="d-flex align-items-center gap-10 justify-content-between">
                            <p className="heading fs-13 ar-dark-color validation_message w-100 text-nowrap">{data?.Patient}</p>
                            <p className='text font-m text-nowrap'>{data?.AccountNumber || ''}</p>
                        </div>

                        <div className="d-flex align-items-center gap-6">
                            <p className="heading font-m ar-light-color">{data?.DOB}</p>
                            <p className="heading font-m ar-light-color">{data?.Age ? `(${data?.Age})` : ''}</p>
                            <p className="heading font-m ar-light-color">{data?.Gender}</p>
                        </div>
                    </div>
                </div>
                {/* <div className='d-flex justify-content-between align-items-center gap-10'>
                    <p className='text font-m ar-light-color'>Account #</p>
                    <p className='text font-m text-nowrap validation_message'>{data?.AccountNumber || ''}</p>
                </div> */}
                <div className='d-flex justify-content-between align-items-center gap-10'>
                    <p className='text font-m ar-light-color'>Cell Phone</p>
                    <p className='text font-m'>{data?.['Phone#'] ? FormatPhoneNumber(data?.['Phone#']) : 'Not Recorded'}</p>
                </div>
                <div className='d-flex justify-content-between align-items-center gap-10'>
                    <p className='text font-m ar-light-color pe-5'>Payer</p>
                    <p className='text font-m text-nowrap validation_message'>{data?.Insurance || 'Not Assigned'}</p>
                </div>
                <div className='d-flex justify-content-between align-items-center gap-10'>
                    <p className='text font-m ar-light-color'>Last Visit</p>
                    <p className='text font-m text-nowrap validation_message'>{data?.LastVisit || 'No Previous Record'}</p>
                </div>
            </div>
            {([ true, "true"].includes(IsProvider) && data?.PsychotherapyNote === "true") &&
            <div className="br-bottom-1px d-flex flex-column gap-1 mb-2 p-2 za-light px-2">
                <div className="Psychotherapy-content">
                    <div className="d-flex align-items-center justify-content-between">
                        <p className="heading fs-13">Psychotherapy Note</p>
                        <i className={`${data?.PsychotherapyNoteID ? `icon-edit-pencil fs-13 ` : `icon-dash-plus fs-19 `}`} onClick={AddPsychoTherapyNote}></i> 
                    </div>
                    {/* ///////////// Can be Updated Data ////////////////// */}
                    {data?.PsychotherapyNotes &&
                    (<div className="mt-1 has-data">
                        {isVisuallyEmpty(data?.PsychotherapyNotes) ?
                                    noValExistText :
                                    <p className="text multiline-ellipsis" dangerouslySetInnerHTML={{ __html: data?.PsychotherapyNotes }}></p>}
                    </div>)}
                </div>
            </div>
            }
        </>
    )
}

export default PatientInformation